<template>
  <vs-popup title="Detalle de Firma Masiva" :active.sync="isActive">
    <div v-if="containerDetails" class="p-2">
      
      <vs-tabs v-model="activeTab" class="container-tabs">
        <vs-tab label="Detalles firma masiva">
          <div class="tab-text mt-4">
            
            <vs-card>
              <div class="p-4">
                <!-- <div slot="header">
                  <h4 class="pb-2 text-primary font-bold">Resumen:</h4>
                </div> -->
                
                <div class="flex items-center justify-between mb-2">
                  <h4 class="font-bold">
                    <span class="text-primary">Firma Masiva:</span> {{ containerDetails.attributes.name }}
                  </h4>
                  <vs-chip :color="getStatusColor(containerDetails.attributes.status)">
                    {{ getStatusLabel(containerDetails.attributes.status) }}
                  </vs-chip>
                </div>

                <div class="mb-4">
                  <p class="text-grey text-sm">
                    Fecha de creación: {{ formatDate(containerDetails.attributes.created_at) }}
                  </p>
                </div>

                <div v-if="containerDetails.attributes.description" class="mb-4">
                  <h6 class="text-grey mb-1">Descripción:</h6>
                  <p>{{ containerDetails.attributes.description }}</p>
                </div>

                <vs-divider class="my-4" />

                <!-- Upload Actions -->
                <div>
                  <div class="vx-row mb-4">
                    <div class="vx-col w-full sm:w-1/2 mb-4 sm:mb-0">
                      <vs-button class="w-full" type="border" icon="icon-upload" icon-pack="feather" @click="uploadDocument" :disabled="containerDetails.attributes.status !== 'ON_HOLD'">Subir documento</vs-button>
                    </div>
                    <div class="vx-col w-full sm:w-1/2">
                      <vs-button class="w-full" type="border" icon="icon-layers" icon-pack="feather" @click="uploadMassive" :disabled="containerDetails.attributes.status !== 'ON_HOLD'">Agregar masivos</vs-button>
                    </div>
                  </div>

                  <vs-divider class="my-4" />
                </div>

                <!-- Download Actions -->
                <div class="vx-row">
                  <div class="vx-col w-full sm:w-1/2 mb-4 sm:mb-0">
                    <vs-button class="w-full" color="primary" type="gradient" icon="icon-download-cloud" icon-pack="feather" @click="downloadContainer">Descargar todo</vs-button>
                  </div>
                  <div class="vx-col w-full sm:w-1/2">
                    <vs-button class="w-full" color="dark" type="border" icon="icon-file-text" icon-pack="feather" @click="downloadResume">Descargar resumen</vs-button>
                  </div>
                </div>
              </div>
            </vs-card>

            <vs-card class="mb-4">
              <div class="p-1">
                <vs-list>
                  <vs-list-header title="Firmantes" class="pt-0" color="primary"></vs-list-header>
                  
                  <template v-if="containerDetails.relationships && containerDetails.relationships.signatures && containerDetails.relationships.signatures.data.length > 0">
                    <vs-list-item 
                      class="list-item" 
                      v-for="(signer, index) in containerDetails.relationships.signatures.data" 
                      :key="'signer-' + index" 
                      :title="signer.attributes.name" 
                      :subtitle="signer.attributes.email"
                    >
                      <vs-avatar slot="avatar" :text="signer.attributes.name.split(' ').slice(0,2).join(' ').trim()" />
                      
                      <vs-chip :color="getStatusColor(signer.attributes.status)" transparent>
                           {{ getStatusLabel(signer.attributes.status) }}
                         </vs-chip>
                    </vs-list-item>
                  </template>
                  <div v-else class="text-center text-grey p-8">
                    <feather-icon icon="UsersIcon" svgClasses="w-8 h-8 mb-2 opacity-25" />
                    <p>No hay firmantes asignados.</p>
                  </div>
                </vs-list>
              </div>
            </vs-card>

            <vs-card class="mb-0">
              <div class="p-1">
                <vs-list>
                  <vs-list-header title="Espectadores" class="pt-0" color="primary"></vs-list-header>
                  
                  <template v-if="containerDetails.relationships && containerDetails.relationships.spectators && containerDetails.relationships.spectators.data.length > 0">
                    <vs-list-item 
                      class="list-item" 
                      v-for="(spectator, index) in containerDetails.relationships.spectators.data" 
                      :key="'spectator-' + index" 
                      :title="spectator.attributes.name" 
                      :subtitle="spectator.attributes.email"
                    >
                      <vs-avatar slot="avatar" :text="spectator.attributes.name.split(' ').slice(0,2).join(' ').trim()" />
                    </vs-list-item>
                  </template>
                  <div v-else class="text-center text-grey p-8">
                    <feather-icon icon="EyeIcon" svgClasses="w-8 h-8 mb-2 opacity-25" />
                    <p>No hay espectadores asignados.</p>
                  </div>
                </vs-list>
              </div>
            </vs-card>

            <!-- <vs-card class="mt-4">
              <div class="p-4">
                <h4 class="mb-4 text-primary font-bold">Datos JSON del Contenedor:</h4>
                <div class="bg-grey-light p-4 rounded-lg overflow-x-auto">
                  <pre class="text-sm"><code>{{ JSON.stringify(containerDetails, null, 2) }}</code></pre>
                </div>
              </div>
            </vs-card> -->

          </div>
        </vs-tab>

        <vs-tab label="Documentos">
          <div class="tab-text mt-4">
            <vs-card class="mb-0">
              <div class="p-4">
                <div class="flex items-center justify-between mb-6">
                  <h4 class="text-primary font-bold">Listado de documentos</h4>
                  <vs-button 
                    type="flat" 
                    icon="icon-refresh-cw" 
                    icon-pack="feather" 
                    size="small" 
                    @click="manualRefreshDocuments"
                    :disabled="isDocumentsLoading"
                  >Refrescar</vs-button>
                </div>
                
                <vs-list>
                  <div v-if="isDocumentsLoading" class="text-center p-8">
                    <vs-progress indeterminate color="primary"></vs-progress>
                    <p class="mt-2 text-grey">Cargando documentos...</p>
                  </div>
                  <template v-else-if="paginatedDocuments && paginatedDocuments.length > 0">
                    <vs-list-item 
                      v-for="(doc, index) in paginatedDocuments" 
                      :key="index" 
                      :title="doc.attributes ? doc.attributes.original_name : doc.original_name || 'Documento sin nombre'" 
                      :subtitle="doc.attributes.file_name"
                    >
                      <vs-avatar slot="avatar" icon="icon-file-text" icon-pack="feather" />
                    </vs-list-item>
                  </template>
                  <div v-else class="text-center text-grey p-8">
                    <feather-icon icon="FileIcon" svgClasses="w-8 h-8 mb-2 opacity-25" />
                    <p>No hay documentos asignados.</p>
                  </div>
                </vs-list>
              </div>
            </vs-card>

            <!-- Pagination -->
            <div class="mt-4 flex justify-center" v-if="documents && documents.length > itemsPerPage">
              <vs-pagination :total="totalPages" v-model="currentPage" :max="5"></vs-pagination>
            </div>
          </div>
        </vs-tab>

        <vs-tab label="Carga Masiva">
          <div class="tab-text mt-4">
            <vs-card>
              <div class="p-4">
                <div class="flex items-center justify-between mb-6">
                  <h4 class="text-primary font-bold">Registro de Carga Masiva (ZIP)</h4>
                  <vs-button 
                    type="flat" 
                    icon="icon-refresh-cw" 
                    icon-pack="feather" 
                    size="small" 
                    @click="manualRefreshActivity"
                    :disabled="isActivityLoading"
                  >Refrescar</vs-button>
                </div>
                
                <div v-if="isActivityLoading" class="text-center p-8">
                  <vs-progress indeterminate color="primary"></vs-progress>
                  <p class="mt-2 text-grey">Obteniendo actividad...</p>
                </div>
                
                <vs-list v-else-if="activityLog && activityLog.length > 0">
                  <vs-list-item 
                    v-for="(item, index) in activityLog" 
                    :key="index" 
                    :title="getFileName(item.gcsObject)" 
                    :subtitle="formatDate(item.createdAt)"
                  >
                    <template slot="avatar">
                      <vs-avatar 
                        :icon="getActivityIcon(item.status)" 
                        :color="getActivityStatusColor(item.status)" 
                        icon-pack="feather" 
                      />
                    </template>
                    
                    <div class="flex flex-col items-end w-full ml-4">
                      <div class="flex justify-between items-center w-full mb-1">
                          <span class="text-xs text-grey" v-if="item.status === 'DONE'">
                            Archivo subido correctamente
                          </span>
                          <span class="text-xs text-grey" v-else-if="item.status === 'PROCESSING'">
                            Procesando archivo...
                          </span>
                          <span class="text-xs text-grey" v-else-if="item.status === 'QUEUED'">
                            En cola de procesamiento...
                          </span>
                          <span class="text-xs text-grey" v-else>
                            {{ getActivityStatusLabel(item.status) }}
                          </span>
                          <span v-if="item.errorMessage" class="text-danger text-xs">{{ item.errorMessage }}</span>
                      </div>
                      
                      <div v-if="['PROCESSING', 'QUEUED'].includes(item.status)" class="w-full flex justify-start py-2">
                          <div class="circular-loader" :class="{'warning': item.status === 'QUEUED'}"></div>
                      </div>
                      
                      <vs-progress 
                        v-else-if="item.status !== 'DONE'"
                        :percent="getProgressValue(item)" 
                        :color="getActivityStatusColor(item.status)"
                        class="block"
                        style="height: 6px;"
                      ></vs-progress>
                    </div>
                  </vs-list-item>
                </vs-list>

                <div v-else class="text-center text-grey p-8">
                  <feather-icon icon="ActivityIcon" svgClasses="w-8 h-8 mb-2 opacity-25" />
                  <p>No hay actividad registrada en esta firma masiva.</p>
                </div>
              </div>
            </vs-card>
          </div>
        </vs-tab>
      </vs-tabs>

    </div>
    <div v-else class="p-8 text-center flex flex-col items-center justify-center">
        <vs-progress indeterminate color="primary" v-if="isLoading"></vs-progress>
        <p v-if="isLoading" class="mt-4 text-grey">Obteniendo información...</p>
    </div>
  </vs-popup>
</template>

<script>
import moment from 'moment';

export default {
  name: "ContainerDetailsModal",
  props: {
    active: {
      type: Boolean,
      required: true
    },
    containerUuid: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      containerDetails: null,
      documents: [],
      activityLog: [],
      activeTab: 0,
      isLoading: false,
      isDocumentsLoading: false,
      isActivityLoading: false,
      statusOptions: [
        { label: 'Todos', value: '' },
        { label: 'En espera', value: 'ON_HOLD' },
        { label: 'Cerrado', value: 'CLOSED' },
        { label: 'Firmando', value: 'SIGNING' },
        { label: 'Firmado', value: 'SIGNED' },
        { label: 'Parcialmente firmado', value: 'PARTIAL_SIGNED' },
        { label: 'Rechazado', value: 'REJECTED' },
        { label: 'Error', value: 'ERROR' }
      ],
      currentPage: 1,
      itemsPerPage: 5,

      refreshHistory: [],
      autoRefreshInterval: null,
      processingProgress: {},
      simulationInterval: null
    }
  },
  computed: {
    isActive: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit('close', val);
      }
    },
    totalPages() {
      return Math.ceil(this.documents.length / this.itemsPerPage);
    },
    paginatedDocuments() {
      const from = (this.currentPage - 1) * this.itemsPerPage;
      const to = from + this.itemsPerPage;
      return this.documents.slice(from, to);
    }
  },
  watch: {
    active(val) {
      if (val && this.containerUuid) {
        this.fetchDetails();
        this.fetchDocuments();
        this.fetchActivity();
        if (this.activeTab === 2) {
            this.startAutoRefresh();
        }
      } else {
        this.containerDetails = null;
        this.documents = [];
        this.activityLog = [];
        this.refreshHistory = [];
        this.activeTab = 0;
        this.currentPage = 1;
        this.stopAutoRefresh();
      }
    },
    activeTab(val) {
        if (val === 2 && this.active) {
            this.startAutoRefresh();
        } else {
            this.stopAutoRefresh();
        }
    }
  },
  methods: {
    fetchDetails() {
      this.isLoading = true;
      this.$store.dispatch("containerManagement/getContainer", this.containerUuid)
        .then(response => {
          this.containerDetails = (response.data && response.data.length > 0) ? response.data[0] : null;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$vs.notify({
            title: 'Error',
            text: 'Error al obtener los detalles de la firma masiva',
            color: 'danger',
            position: 'top-center',
            time: 3000
          });
        });
    },
    fetchActivity() {
      // Don't show loading on auto-refresh to avoid flickering
      if (!this.autoRefreshInterval) {
          this.isActivityLoading = true;
      }
      
      this.$store.dispatch("containerManagement/getUploadProcesses", this.containerUuid)
        .then(response => {
          this.activityLog = response.data || [];
          this.isActivityLoading = false;
          
          // Initialize simulated progress for new processing items
          this.activityLog.forEach(item => {
              if (item.status === 'PROCESSING' && !this.processingProgress[item.id]) {
                  this.$set(this.processingProgress, item.id, 20);
              } else if (item.status === 'DONE') {
                  this.$set(this.processingProgress, item.id, 100);
              }
          });
        })
        .catch(() => {
          this.isActivityLoading = false;
        });
    },
    startAutoRefresh() {
        this.stopAutoRefresh(); // Clear any existing intervals
        
        // Polling every 5 seconds
        this.autoRefreshInterval = setInterval(() => {
            if (this.containerUuid) {
                this.fetchActivity();
            }
        }, 5000);

        // Simulation loop every 1 second
        this.simulationInterval = setInterval(this.simulateProgress, 1000);
    },
    stopAutoRefresh() {
        if (this.autoRefreshInterval) {
            clearInterval(this.autoRefreshInterval);
            this.autoRefreshInterval = null;
        }
        if (this.simulationInterval) {
            clearInterval(this.simulationInterval);
            this.simulationInterval = null;
        }
    },
    simulateProgress() {
        const processingItems = this.activityLog.filter(item => item.status === 'PROCESSING');
        
        processingItems.forEach(item => {
            let current = this.processingProgress[item.id] || 20;
            if (current < 90) { // Cap at 90% until actually DONE
                // Increment by random 1-3%
                const increment = Math.floor(Math.random() * 3) + 1;
                let next = current + increment;
                if (next > 90) next = 90;
                this.$set(this.processingProgress, item.id, next);
            }
        });
    },
    manualRefreshDocuments() {
      if (this.checkRateLimit()) {
        this.fetchDocuments();
      }
    },
    manualRefreshActivity() {
      if (this.checkRateLimit()) {
        this.fetchActivity();
      }
    },
    checkRateLimit() {
      const now = Date.now();
      const oneMinuteAgo = now - 60000;
      
      // Filtrar el historial para mantener solo los de hace menos de un minuto
      this.refreshHistory = this.refreshHistory.filter(timestamp => timestamp > oneMinuteAgo);
      
      if (this.refreshHistory.length >= 10) {
        this.$vs.notify({
          title: 'Límite alcanzado',
          text: 'Espera un minuto antes de refrescar.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-clock',
          position: 'top-center'
        });
        return false;
      }
      
      this.refreshHistory.push(now);
      return true;
    },
    fetchDocuments() {
      this.isDocumentsLoading = true;
      this.$store.dispatch("containerManagement/getDocuments", { uuid: this.containerUuid })
        .then(response => {
          this.documents = response.data || [];
          this.isDocumentsLoading = false;
        })
        .catch(() => {
          this.isDocumentsLoading = false;
          this.$vs.notify({
            title: 'Error',
            text: 'Error al obtener los documentos',
            color: 'danger',
            position: 'top-center',
            time: 3000
          });
        });
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY · HH:mm a');
    },
    getStatusColor(status) {
      if (status === 'SIGNED') return 'success';
      if (status === 'ON_HOLD') return 'warning';
      if (status === 'REJECTED') return 'danger';
      if (status === 'PARTIAL_SIGNED') return 'primary';
      if (status === 'SIGNING') return 'primary';
      if (status === 'CLOSED') return 'dark';
      if (status === 'ERROR') return 'danger';
      return 'primary';
    },
    getStatusLabel(status) {
      const option = this.statusOptions.find(opt => opt.value === status);
      return option ? option.label : status;
    },
    downloadResume() {
      if (!this.containerDetails) return;
      
      if (this.containerDetails.attributes.status !== 'SIGNED') {
        this.$vs.notify({
          title: 'Acción no permitida',
          text: 'Solo se puede descargar el resumen cuando la firma masiva está "Firmada"',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center'
        });
        return;
      }
      
      this.$vs.loading();
      this.$store.dispatch("containerManagement/getResume", this.containerUuid)
        .then(blob => {
          this.$vs.loading.close();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${this.containerDetails.attributes.name}_resumen.csv`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          
          this.$vs.notify({
            title: 'Éxito',
            text: 'Resumen descargado correctamente',
            color: 'success',
            position: 'top-center',
            time: 3000
          });
        })
        .catch(error => {
          console.error('Error in downloadResume:', error);
          this.$vs.loading.close();
          const message = (error && error.toString()) || 'Error al descargar el resumen, solo se puede descargar cuando la firma masiva está "Firmada"';
          this.$vs.notify({
            title: 'Error',
            text: message.replace(/ON_HOLD/g, 'En espera'),
            color: 'danger',
            position: 'top-center',
            time: 3000
          });
        });
    },
    uploadDocument() {
      if (this.containerDetails.attributes.status !== 'ON_HOLD') {
        this.$vs.notify({
          title: 'Acción no permitida',
          text: 'Solo se pueden subir documentos cuando la firma masiva está "En espera"',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center'
        });
        return;
      }
      this.$emit('open-upload-single');
    },
    uploadMassive() {
      if (this.containerDetails.attributes.status !== 'ON_HOLD') {
        this.$vs.notify({
          title: 'Acción no permitida',
          text: 'Solo se pueden agregar masivos cuando la firma masiva está "En espera"',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center'
        });
        return;
      }
      this.$emit('open-upload-massive');
    },
    downloadContainer() {
      if (!this.containerDetails) return;
      
      this.$vs.loading();
      this.$store.dispatch("containerManagement/downloadAll", this.containerUuid)
        .then(blob => {
          this.$vs.loading.close();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${this.containerDetails.attributes.name}.zip`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          
          this.$vs.notify({
            title: 'Éxito',
            text: 'Descarga iniciada correctamente',
            color: 'success',
            position: 'top-center',
            time: 3000
          });
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Error',
            text: 'Error al iniciar la descarga',
            color: 'danger',
            position: 'top-center',
            time: 3000
          });
        });
    },
    // Métodos auxiliares para la pestaña de Actividad
    getFileName(path) {
      if (!path) return 'Archivo desconocido';
      const parts = path.split('/');
      return parts[parts.length - 1];
    },
    getActivityStatusLabel(status) {
      const labels = {
        'DONE': 'Completado',
        'PROCESSING': 'Procesando',
        'QUEUED': 'En cola',
        'ERROR': 'Error'
      };
      return labels[status] || status;
    },
    getActivityStatusColor(status) {
      const colors = {
        'DONE': 'success',
        'PROCESSING': 'primary',
        'QUEUED': 'warning',
        'ERROR': 'danger'
      };
      return colors[status] || 'grey';
    },
    getActivityIcon(status) {
      const icons = {
        'DONE': 'icon-check',
        'PROCESSING': 'icon-refresh-cw',
        'QUEUED': 'icon-clock',
        'ERROR': 'icon-alert-circle'
      };
      return icons[status] || 'icon-file';
    },
    getProgressValue(item) {
        if (item.status === 'PROCESSING') {
            return this.processingProgress[item.id] || 20;
        }

        const progress = {
            'QUEUED': 10,
            'DONE': 100,
            'ERROR': 100
        }
        return progress[item.status] || 0
    }
  },
  beforeDestroy() {
      this.stopAutoRefresh();
  }
}
</script>

<style lang="scss">
.container-tabs {
  .vs-tabs--ul {
    display: flex;
    flex-wrap: nowrap;
    border-bottom: 1px solid rgba(0,0,0,.05);
    width: 100%;
    
    li {
      flex: 1;
      min-width: 0;
      
      button {
        padding: 10px 5px !important;
        font-size: 0.9rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
      }
    }
  }

  .vs-tabs--content {
    padding: 0;
  }
}

@media (max-width: 600px) {
  .container-tabs {
    .vs-tabs--ul li button {
      white-space: normal !important;
      font-size: 0.75rem;
      line-height: 1.1;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@media (max-width: 500px) {
  .vs-popup--content {
    padding: 0.5rem !important;
  }
  
  .vs-card {
    margin-bottom: 1rem !important;
  }

  h4 {
    font-size: 1.1rem;
    line-height: 1.2;
  }

  .vs-list--item {
    .vs-list--title {
      font-size: 0.9rem;
    }
    .vs-list--subtitle {
      font-size: 0.8rem;
    }
  }
}

.circular-loader {
  border: 3px solid #f3f3f3;
  border-top: 3px solid rgba(var(--vs-primary), 1);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
  
  &.warning {
    border-top: 3px solid rgba(var(--vs-warning), 1);
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
